import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import ProductPricingAdjustmentButton from 'module/productManagement/components/productPricingButton/ProductPricingAdjustmentButton';
import ProductPricingButton from 'module/productManagement/components/productPricingButton/ProductPricingButton';
import { isDesktop, isMobile } from 'react-device-detect';
import { ProductAction, useProductProvider } from '../Product.Hooks';
import ProductFilters from './Product.Filters';

export default function ProductList() {
  const { lang, translate } = getLocales();
  const { listApi, cloneApi, pageRouter, permissions, selected } = useProductProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.products}
      render={lang.noInfo}
    />
  ) : (
    <Page
      class={ThemePageList}
      isLoading={listApi.isExecuting}
      header={
        <>
          <h2 style={{ marginRight: 'auto' }} children={lang.products} />
          <Box class={ThemeWrapperStack}>
            {isMobile && <ProductFilters />}
            <Button
              class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
              active
              media={<Icon class="fas-plus" />}
              render={!isMobile && lang.addNew}
              onClick={pageRouter.updateParams}
              disabled={!permissions.CREATE_PRODUCT}
              data={{ action: ProductAction.EDIT }}
            />
          </Box>
        </>
      }
      subHeader={isDesktop && <ProductFilters />}
      render={
        <>
          {selected && pageRouter.params.action === ProductAction.CLONE && (
            <Confirm
              data={selected}
              onConfirm={(data) => cloneApi.execute(data.id)}
              onClose={pageRouter.updateParams}
              actionName={lang.cloneProduct}
              itemName={selected.name}
              confirmationType="nextButton"
              subcomponents={ThemeConfirmDefault}
            />
          )}
          <table className={ThemeTableSimple}>
            <thead>
              <tr>
                <th>{lang.code}</th>
                <th>{lang.name}</th>
                <th>{lang.program}</th>
                <th>{lang.type}</th>
                <th>{lang.pricingDistributionTemplate}</th>
                <th data-actions>{lang.actions}</th>
              </tr>
            </thead>
            <tbody>
              <DataMap
                data={listApi.payload?.data}
                render={({ data: product }) => (
                  <tr key={product.id}>
                    <td>
                      <b>{product.code}</b>
                    </td>
                    <td>{product.name}</td>
                    <td>{product.category?.name}</td>
                    <td>{translate(product.productType)}</td>
                    <td>{product.pricingDistributionTemplate?.name}</td>
                    <td>
                      <Box class={ThemeWrapperStack}>
                        <Button
                          onClick={pageRouter.updateParams}
                          data={{
                            id: product.id.toString(),
                            action: ProductAction.EDIT,
                          }}
                          disabled={!permissions.EDIT_PRODUCT}
                          class={ThemeButtonCircle}
                          media={<Icon class="fas-edit" />}
                          htmlElementProps={{ title: lang.edit }}
                          active
                        />
                        <Button
                          onClick={pageRouter.updateParams}
                          data={{
                            id: product.id.toString(),
                            action: ProductAction.DELETE,
                          }}
                          disabled={!permissions.DELETE_PRODUCT}
                          class={ThemeButtonCircle}
                          media={<Icon class="fas-trash" />}
                          htmlElementProps={{ title: lang.delete }}
                          active
                        />
                        <ProductPricingAdjustmentButton
                          id={product?.id}
                          dataType="product"
                          productType={product?.productType}
                        />
                        <ProductPricingButton product={product} />
                        <Button
                          onClick={pageRouter.updateParams}
                          data={{
                            id: product.id.toString(),
                            action: ProductAction.CLONE,
                          }}
                          disabled={!permissions.CREATE_PRODUCT}
                          class={ThemeButtonCircle}
                          media={<Icon class="fas-copy" />}
                          htmlElementProps={{ title: lang.cloneProduct }}
                          active
                        />
                      </Box>
                    </td>
                  </tr>
                )}
              />
            </tbody>
          </table>
        </>
      }
      footer={
        <Pagination
          class={ThemePaginationRounded}
          count={listApi.payload?.count}
          offset={listApi.body?.offset}
          limit={listApi.body?.limit}
          onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
          onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
        />
      }
    />
  );
}
